import { Text } from "theme-ui";
import { CallMe } from "../../../../src/components/call-me";
import * as React from 'react';
export default {
  Text,
  CallMe,
  React
};